import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdGroup, MdShowChart, MdLocationOn } from 'react-icons/md';
import styled from 'styled-components';
import PageContainer from '../../../../shared/layout/containers/PageContainer';
import PageHeader from '../../../../shared/layout/headers/PageHeader';
import PageTitle from '../../../../shared/layout/titles/PageTitle';
import PageContent from '../../../../shared/layout/containers/PageContent';
import RetailersTable from './RetailersTable';
import RetailersGraph from './RetailersGraph';
import RetailersVenues from './RetailersVenues';

const tabs = [
    { key: 'list', icon: <MdGroup />, labelKey: 'ManufacturerRetailers.tabs.list' },
    { key: 'graph', icon: <MdShowChart />, labelKey: 'ManufacturerRetailers.tabs.graph' },
    { key: 'venues', icon: <MdLocationOn />, labelKey: 'ManufacturerRetailers.tabs.venues' },
];

const ManufacturerRetailers = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('list');

    return (
        <PageContainer>
            <PageHeader>
                <TitleGroup>
                    <PageTitle>{t('ManufacturerRetailers.title')}</PageTitle>
                    <Subtitle>{t('ManufacturerRetailers.subtitle')}</Subtitle>
                </TitleGroup>
            </PageHeader>
            <PageContent>
                <Tabs>
                    {tabs.map((tab) => (
                        <TabButton
                            key={tab.key}
                            $active={activeTab === tab.key}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            {tab.icon}
                            <span>{t(tab.labelKey)}</span>
                        </TabButton>
                    ))}
                </Tabs>
                <Content>
                    {activeTab === 'list' && <RetailersTable />}
                    {activeTab === 'graph' && <RetailersGraph />}
                    {activeTab === 'venues' && <RetailersVenues />}
                </Content>
            </PageContent>
        </PageContainer>
    );
};

export default ManufacturerRetailers;

const TitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

const Subtitle = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.textSecondary || '#666'};
`;

const Tabs = styled.div`
    display: flex;
    gap: 0.75rem;
    border-bottom: 1px solid rgba(130, 22, 146, 0.15);
    margin-bottom: 1.25rem;
    padding-bottom: 0.625rem;
`;

const TabButton = styled.button`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: ${({ $active }) => ($active ? 'rgba(130, 22, 146, 0.08)' : 'transparent')};
    border: none;
    border-bottom: ${({ $active }) => ($active ? '3px solid rgba(130, 22, 146, 1)' : '3px solid transparent')};
    color: ${({ $active }) => ($active ? 'rgba(130, 22, 146, 1)' : '#444')};
    padding: 0.625rem 0.75rem;
    font-weight: 600;
    cursor: pointer;

    span {
        font-size: 0.95rem;
    }

    svg {
        font-size: 1.2rem;
    }
`;

const Content = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    padding: 1.25rem;
`;
